import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import translate from 'components/hoc/translate';
import styled from 'styled-components';
import Loader from 'components/loading/Loader';
import { compose } from 'redux';
import RaisedButton from 'material-ui/RaisedButton';
import ReservationSessionForm from '../session/ReservationSessionForm';

const StyledLoaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledContentWrapper = styled.div`
    min-height: 72px;
`;

const ReservationOpenBarrierModal = (props) => {
    const {
        accessPoints,
        accessPointsAccessMethods,
        isLoading,
        message,
        onCloseModal,
        onHandleSubmit,
        onSelectAccessPoint,
        phase,
        translate,
    } = props;

    const showLoader = phase === 'loading' || isLoading;
    const closeAction = <RaisedButton label={ translate(`actions.close`) } onTouchTap={ onCloseModal } key='close' />;

    return (
        <Dialog
            actions={ !!message && closeAction }
            modal={ false }
            onRequestClose={ onCloseModal }
            open={ true }
            title={ translate('resources.reservations.open_barrier.title') }
        >
            <StyledContentWrapper>
                { showLoader &&
                    <StyledLoaderWrapper>
                        <Loader />
                    </StyledLoaderWrapper>
                }

                {
                    phase === 'options' &&
                        <ReservationSessionForm
                            onSelectAccessPoint={ onSelectAccessPoint }
                            accessPoints={ accessPoints }
                            accessPointsAccessMethods={ accessPointsAccessMethods }
                            buttonLabel={ translate('resources.reservations.session.button.open_barrier') }
                            description={ translate('resources.reservations.open_barrier.description') }
                            form='reservationSessionForm'
                            onHandleSubmit={ onHandleSubmit }
                            onCloseModal={ onCloseModal }
                            openGate={ props.openGate }
                            toggleOpenGate={ props.toggleOpenGate }
                            translate={ translate }
                            title={ translate('resources.reservations.open_barrier.title') }
                        />
                }

                { phase === 'result' &&
                    <div>{ message }</div>
                }

            </StyledContentWrapper>
        </Dialog>
    );
};

const enhance = compose(
    translate,
);

ReservationOpenBarrierModal.propTypes = {
    accessPoints: PropTypes.object,
    accessPointsAccessMethods: PropTypes.object,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
    onCloseModal: PropTypes.func.isRequired,
    onHandleSubmit: PropTypes.func.isRequired,
    onSelectAccessPoint: PropTypes.func.isRequired,
    openGate: PropTypes.bool,
    phase: PropTypes.string.isRequired,
    toggleOpenGate: PropTypes.func,
    translate: PropTypes.func.isRequired,
};

export default enhance(ReservationOpenBarrierModal);


// WEBPACK FOOTER //
// ./src/pages/reservations/show/open-barrier/ReservationOpenBarrierModal.js